import { useEffect, useState } from 'react';
import { NavLink, Route, Routes, useNavigate } from 'react-router-dom';
import { exchangeCode, isAuthenticated, logout, startLogin } from './auth';
import Dashboard from './pages/Dashboard';
import Summary from './pages/Summary';
import Users from './pages/Users';
import Apps from './pages/Apps';
import Rotation from './pages/Rotation';
import TapRates from './pages/TapRates';
import Masks from './pages/Masks';
import Devices from './pages/Devices';
import DeviceDetail from './pages/DeviceDetail';
import Export from './pages/Export';

function Login() {
  return (
    <div className="center">
      <div className="card">
        <h2>apps-hub admin</h2>
        <p className="muted">Sociama 内部管理コンソール</p>
        <button onClick={() => void startLogin()}>Cognito でサインイン</button>
      </div>
    </div>
  );
}

function Callback() {
  const nav = useNavigate();
  const [err, setErr] = useState<string | null>(null);
  const [debug, setDebug] = useState<Record<string, string>>({});
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const all: Record<string, string> = {};
    params.forEach((v, k) => (all[`?${k}`] = v));
    hash.forEach((v, k) => (all[`#${k}`] = v));
    setDebug(all);
    const code = params.get('code');
    const oauthErr = params.get('error');
    if (!code) {
      // OAuth 側から明示的なエラーが来た場合だけ画面に出す。
      // それ以外 (ブックマーク直開き / reload 等で /callback に params 無しで来た) は
      // 既に認証済みなら / へ、そうでなければログインを開始する。
      if (oauthErr) {
        const errDesc = params.get('error_description');
        setErr(`${oauthErr}: ${errDesc || ''}`);
        return;
      }
      if (isAuthenticated()) {
        nav('/', { replace: true });
      } else {
        void startLogin();
      }
      return;
    }
    exchangeCode(code)
      .then(() => nav('/', { replace: true }))
      .catch((e) => setErr(String(e)));
  }, [nav]);
  return (
    <div className="center">
      <div className="card" style={{ maxWidth: 640 }}>
        <h2>サインイン中…</h2>
        {err && <div className="error">{err}</div>}
        {Object.keys(debug).length > 0 && (
          <div style={{ marginTop: 12 }}>
            <div className="muted" style={{ fontSize: '0.85em' }}>
              URL params:
            </div>
            <pre
              style={{
                background: 'var(--bg)',
                padding: 12,
                borderRadius: 6,
                overflow: 'auto',
                fontSize: '0.8em',
              }}
            >
              {JSON.stringify(debug, null, 2)}
            </pre>
          </div>
        )}
        <div style={{ marginTop: 12 }}>
          <a href="/">← ログイン画面に戻る</a>
        </div>
      </div>
    </div>
  );
}

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="app">
      <aside className="sidebar">
        <h1>APPS-HUB</h1>
        <nav>
          <NavLink to="/" end>
            ダッシュボード
          </NavLink>
          <NavLink to="/summary">サマリー</NavLink>
          <NavLink to="/users">テストユーザー</NavLink>
          <NavLink to="/apps">アプリマスタ</NavLink>
          <NavLink to="/rotation">広告ローテ</NavLink>
          <NavLink to="/tap-rates">タップ率</NavLink>
          <NavLink to="/masks">プリフィックスマスク</NavLink>
          <NavLink to="/devices">端末</NavLink>
          <NavLink to="/export">CSVエクスポート</NavLink>
        </nav>
        <div className="sidebar-footer">
          <button className="ghost small" onClick={logout}>
            ログアウト
          </button>
        </div>
      </aside>
      <main className="main">{children}</main>
    </div>
  );
}

export default function App() {
  const path = window.location.pathname;
  const isCallback = path === '/callback';
  const [authed, setAuthed] = useState<boolean>(isAuthenticated());

  useEffect(() => {
    const check = () => setAuthed(isAuthenticated());
    const iv = setInterval(check, 30_000);
    return () => clearInterval(iv);
  }, []);

  if (isCallback) return <Callback />;
  if (!authed) return <Login />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/summary" element={<Summary />} />
        <Route path="/users" element={<Users />} />
        <Route path="/apps" element={<Apps />} />
        <Route path="/rotation" element={<Rotation />} />
        <Route path="/tap-rates" element={<TapRates />} />
        <Route path="/masks" element={<Masks />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/devices/:name" element={<DeviceDetail />} />
        <Route path="/export" element={<Export />} />
      </Routes>
    </Layout>
  );
}
